import React from "react";
import "./guest.css";
import Guestprops from "./guestprops";
import Singer1 from "../../atrimages/guest/singer.jpg";
// import Singer2 from "../../atrimages/guest/singer2.jpg";

export default function Committe() {
  return (
    <div className="gCommitteWrapper">
      <div className="gcommitteTitle">
        <h1>
          Hello Guys..... <br />
          #HAVE THE FUN
        </h1>
        <br />
        <p>
          Vibe to the concerts of some of India's finest musicians, comedians,
          and DJs! Get ready to groove and make memories that'll last a
          lifetime. Not only will you breathe fun-filled flavours of air, and
          meet new people; but you'll also become a part of an ever-blossoming
          community of <b>ATRI Parvathapoor,Hyderabad</b>. So, buckle up and
          grab your squad and let the good vibes roll, adding an extra
          perfection to the hymn of your steps.
        </p>
      </div>
      <br />
      <div className="MUSIC">
        <Guestprops
          className="signer1"
          image={Singer1}
          title="MUSIC"
          date="17th JUNE - 7:00PM"
          organiser="Ms.HarikaNarayan"
          desc="We have added another special attraction to our BOREALIS'23.Ms.  HarikaNarayan, is one of the popular playback singers in the Telugu industry. She will be a part of our event on 17/06/2023"
        />
        {/* <Guestprops
          image={Singer2}
          title="Music"
          date="17th JUNE - 7:00PM"
          organiser="Ms.HarikaNarayan"
          desc="We have added another special attraction to our BOREALIS'23.Ms.  HarikaNarayan, is one of the popular playback singers in the Telugu industry. She will be a part of our event on 17/06/2023"
        /> */}
      </div>
    </div>
  );
}
